module.exports = __webpack_public_path__ + "img/chat.3728bf3c.svg";